<template>
    <v-dialog
      v-model="show"
      @click:outside="closeModal"
      width="700"
    >
        <v-card>

            <v-card-title 
                class="text-h5 white--text"
                style="background-color:#5087e6;"
            >
            {{ containerDefaultDialogSetting.title }}
            </v-card-title>

            <v-card-text>

                <v-form ref="form" class="mx-2" lazy-validation @submit.prevent>
                    <v-container>

                        <v-row v-for="(item) in Object.values(containerDefaultDialogSetting.fields)" :key="item.id">

                            <v-col
                                md="12"
                                class="pr-0 pl-0 pt-0 pb-0 mt-3"
                            >

                                <div v-for="(service,idx) in item" :key="service.id">

                                    <div>

                                        <h2 class="pa-2" v-if="idx === 0">{{ service['category'] }}</h2>

                                        <v-divider class="mb-4" v-if="idx === 0"></v-divider>

                                        <h4 v-if="idx !== 0">
                                            {{ service.label }}
                                        </h4>

                                        <v-text-field
                                            v-if="(service.type === 'text' || service.type  === undefined) && idx !== 0"
                                            :success="!!service.value"
                                            v-model.trim="service.value"
                                            
                                            outlined
                                            height="12"
                                            dense
                                            :hint="service.hint"
                                            validate-on-blur
                                            color="primary"
                                        ></v-text-field>
                                    </div>

                                    

                                </div>

                            </v-col>

                        </v-row>

                    </v-container>

                </v-form>   

            </v-card-text>  

            <v-divider></v-divider>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn
                    color="primary"
                    text
                    @click="closeModal"
                >
                    取消
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="submit"
                >
                    {{containerDefaultDialogSetting.submit_text}}
                </v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>       

</template>

<script>
export default {
    name: "ContainerDialogForm",
    props: {
      containerDefaultDialogSetting: {
          type: Object
      },
    },
    data() {
        return {
            show: true,
            rules: this.$utils.field_rules,
        }
    },
    created() {

    },
    mounted() {
        console.log("yaayya");
    },
    computed: {
        display() {
            return this.service?.['category']
        }
    },
    methods: {
        closeModal() {
            // this.$emit('closeModal')
            this.$emit(this.containerDefaultDialogSetting.close_callback)
        },
        submit() {
            let result = this.$refs.form.validate();

            if (!result) {
                return
            }
            // let params = {param1: this.containerDefaultDialogSetting.fields, param2: this.containerDefaultDialogSetting.title};
            this.$emit(this.containerDefaultDialogSetting.submit_callback, this.containerDefaultDialogSetting)
        }
    },
    destroyed() {

    }
}
</script>

<style scoped>

</style>